// Builds the log line for a native social sign-in result WITHOUT any of its values.
//
// The SocialLogin plugin's result carries live credentials (the Google `idToken`, which can be
// exchanged for a Firebase sign-in for about an hour, and an access token) plus the person's email
// and name. Every console call becomes a Sentry breadcrumb, in production too (LoggingService), and
// the breadcrumb redactor only strips credentials out of page addresses, so logging the result
// itself sent those values to Sentry (deferred finding df-20b2ac3b725f; the 2026-07-01 incident in
// design-docs/secrets-inventory.md). This reports only WHICH fields came back, as yes/no.
//
// Kept free of Angular and the plugin import so it can be unit-tested in node.

/** "yes" when the value is present and not empty, "no" otherwise. Never echoes the value. */
function presence(value: unknown): 'yes' | 'no' {
  if (value === null || value === undefined || value === '') return 'no';
  return 'yes';
}

/**
 * e.g. `provider=google idToken=yes accessToken=yes profile=yes`.
 * `res` is the plugin's `SocialLogin.login()` answer, typed loosely because its shape differs per
 * provider and per plugin version; a missing `result` reads as every field absent.
 */
export function describeSocialLoginResultForLog(provider: string, res: unknown): string {
  const result = (res as { result?: Record<string, unknown> } | null | undefined)?.result;
  const fields = [
    `provider=${provider}`,
    `idToken=${presence(result?.idToken)}`,
    `accessToken=${presence(result?.accessToken)}`,
    `profile=${presence(result?.profile)}`,
  ];
  return fields.join(' ');
}
